import { useSelector } from "react-redux";
import { FirebaseState } from "../../utilities/firebaseState";
import { RegisterState } from "./slice";

export const useRegisterState = () => {
    return useSelector(
        (state: { register: RegisterState; firebase: FirebaseState }) => state
    );
};
